export default __webpack_public_path__ + "static/media/wap_platform_introduction_pic3.cfb51ec6.png";